require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./crches-et-garderies-1-1-16.json") })
        }
      }, "path---crches-et-garderies-1-1-16");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---crches-et-garderies-1-1-16!./.cache/json/crches-et-garderies-1-1-16.json
// module id = 388
// module chunks = 231608221292675